import React, { useMemo } from 'react'
import Image from 'components/Common/Image'
import Clickable from 'components/Common/Clickable'
import qs from 'qs'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useImpressionHandler from 'hooks/useImpressionHandler'

interface Props {
  promoBanner: App.CruisePromoBanner
}

function CruisePromoTileItem({ promoBanner } : Props) {
  const impressionRef = useImpressionHandler(promoBanner.id)

  const bannerLink = useMemo(() => {
    let endpoint = '/search/cruises'
    const redirectData = promoBanner.redirectData || ''

    switch (promoBanner.redirectType) {
      case 'LANDING_PAGE':
        endpoint = `/${redirectData}`
        break
      case 'RATE_CODE':
        const query = qs.stringify({ rateCode: redirectData })
        endpoint = `/search/cruises?${query}`
        break
      case 'SEARCH_FILTERS':
        endpoint = `/search/cruises?${redirectData}`
        break
      case 'CRUISE_OFFER':
        endpoint = `/cruises/${redirectData}`
        break
      case 'FLASH_OFFER':
        endpoint = `/offer/${redirectData}`
        break
      default:
        endpoint = '/search/cruises'
    }

    return endpoint
  }, [promoBanner])

  return <Clickable to={bannerLink} ref={impressionRef}>
    <CSSBreakpoint min="tablet">
      <Image
        fit="center"
        id={promoBanner.imageId}
        alt={promoBanner.imageId}
      />
    </CSSBreakpoint>

    <CSSBreakpoint max="mobile">
      <Image
        fit="center"
        id={promoBanner.mobileImageId}
        alt={promoBanner.imageId}
      />
    </CSSBreakpoint>
  </Clickable>
}

export default CruisePromoTileItem
